<template>
    <div class="body">
        <div class="back" @click="$router.go(-1)">
            <img src="../../assets/img/i19.png" />
            返回
        </div>
        <div class="list" :infinite-scroll-distance="50" :infinite-scroll-immediate="false" v-infinite-scroll="load">
            <div class="item">
                <el-empty description="暂无数据" v-if="list.length == 0"></el-empty>
                <div class="i_bottom" v-for="(item, index) in list" :key="index" @click="btn_open(item)">
                    <div class="ib_content">
                        <div class="ibc_top">{{ item.helperName }}</div>
                        <div class="ibc_center line1_">{{ item.lastChatContent }}</div>
                        <div class="ibc_bottom">{{ item.lastChatTimeStr }}</div>
                    </div>
                    <div class="ib_btn">
                        <img src="../../assets/img/i91.png" @click.stop="btn_item(item, index, 2)" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { presetHelperSessionList,universalHelperSessionDelete } from '@/apis/index'
export default {
    data() {
        return {
            list: [],
            pageNum: 1,
            pageSize: 20,
            total: 0,
            helperId: this.$route.query.id
        }
    },
    methods: {
        btn_item(item) {
            this.$confirm('是否确定删除该条记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                universalHelperSessionDelete(item.id).then(res => {
                    console.log(res, 'universalHelperSessionDelete');
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.pageNum = 1
                    this.getList()
                })
            })
        },
        btn_open(item) {
            this.$router.push({
                path: '/intelligentBodyChat',
                query: {
                    item: JSON.stringify(item)
                }
            })
        },
        load() {
            this.throttle(() => {
                if (this.total > this.list.length) {
                    this.pageNum++
                    this.getList()
                }
            })
        },
        getList() {
            presetHelperSessionList(this.helperId, this.pageNum, this.pageSize).then(res => {
                console.log(res, 'res');
                if (this.pageNum == 1) {
                    this.list = []
                }
                this.list = [...this.list, ...res.data.list]
                this.total = res.data.total
            })
        }
    },
    mounted() {
        this.getList()
    }
}
</script>

<style lang="scss" scoped>
.line1_ {
    word-break: break-all;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

.body {
    width: 1200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .back {
        width: 100%;
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 14px;
        color: #000000;
        // margin-bottom: 10px;
        margin-top: 10px;
        cursor: pointer;
        box-sizing: border-box;

        img {
            width: 14px;
            height: 14px;

        }
    }

    .list::-webkit-scrollbar {
        display: none;
    }

    .list {
        width: 900px;
        height: 0;
        flex: 1;
        box-sizing: border-box;
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow-y: scroll;

        .item {
            width: 100%;
            margin-bottom: 20px;

            .i_top {
                font-weight: 400;
                font-size: 24px;
                color: #212121;
            }

            .i_bottom {
                width: 100%;
                // height: 98px;
                background: #FFFFFF;
                border-radius: 12px 12px 12px 12px;
                border: 1px solid #E9EBF2;
                margin-top: 20px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                box-sizing: border-box;
                padding: 15px 30px;
                cursor: pointer;

                .ib_content {
                    flex: 1;
                    margin-right: 20px;

                    .ibc_top {
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;
                    }

                    .ibc_center {
                        font-weight: 500;
                        font-size: 16px;
                        color: #333333;
                        margin: 12px 0;
                    }

                    .ibc_bottom {
                        font-weight: 500;
                        font-size: 12px;
                        color: #999999;
                    }
                }

                .ib_btn {
                    display: flex;
                    align-items: center;

                    img {
                        width: 24px;
                        height: 24px;
                        // margin: 0 15px;
                        margin-left: 15px;
                    }
                }
            }
        }
    }
}
</style>